import Vue from 'vue';
import Modal from 'components/modules/accordions-modals/modals/modal/modal.mixin';

Vue.component('register-modal-vue', {
  mixins: [Modal],
});
